import styled from '@emotion/styled';

export const IframeWrapper = styled('iframe', { label: 'IframeWrapper' })`
    border: 0;
`;

export const InfoWrapper = styled('div', { label: 'InfoWrapper' })`
    margin: 5px;
    padding: 15px;
`;
